/* eslint-disable react/require-default-props */

import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

export const ColorLegend = () => {
  const { t } = useTranslation();

  const legendItems = [
    {
      text: t('businessReports.weekly.legendItem1'),
      color: '#e3bff5',
    },
    {
      text: t('businessReports.weekly.legendItem2'),
      color: '#3e0b6c',
    },
  ];

  return (
    <section className="color-legend">
      {legendItems.map((item, index) => (
        <div key={`${item.color}-${index}`} className="color-item">
          <span style={{ backgroundColor: item.color }} />
          {item.text}
        </div>
      ))}
    </section>
  );
};
